import AbstractField from "./abstract";

class TextField extends AbstractField{
    __init_dom_schema(){
        return {
            input: {
                selector: 'input, textarea',
                actions: {
                    'input': this.dispatchEvent.bind(this, 'changed'),
                    'focus': this.focus.bind(this),
                }
                // actions: {
                //     'input': () => {
                //         console.log('test')
                //         // this.dispatchEvent.bind(this, 'changed')
                //         this.dispatchEvent('changed')
                //     },
                //     'focus': this.focus.bind(this),
                // }
            },
            // wrapper: {
            //     selector: '.js-form-field__wrapper',
            //     actions: {
            //         'click': this.onWrapperClicked.bind(this)
            //     }
            // }
        }
    }
    __init(){
        this.registerEvents('changed')

        const mask_installer = this.args?.mask_installer
        if(typeof mask_installer == 'function'){
            this.mask_handler = mask_installer(this.dom.input)
            // console.log('this.mask_handler', this.mask_handler)
        }
    }
    // onWrapperClicked(event){
    //     console.log(event)
    //     // this.dom.input.focus()
    // }
    isRequired(){
        return this.dom.input.hasAttribute('required')
    }
    isFilled(){
        return this.dom.input.value !== ''
    }
    getValue(){
        return this.dom.input.value
    }
    setValue(value){
        this.dom.input.value = value
    }
    unfocus(){
        this.dom.input.blur()
    }
}

export default TextField